/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=45d5758d"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "@/assets/styles/app.css?vue&type=style&index=0&lang=css"

import exportComponent from "/Users/arkane/Dev/Web/Projects/edimamel.proj/edimamel.dev.local/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__